export default __webpack_public_path__ + "static/media/milestone 3200.01301fa9.svg";